import validators from '@utils/validators';

const validate = (values) => {
    const errors = {};

    Object.assign(errors, validators.required(values.stadium, 'stadium'));
    Object.assign(errors, validators.required(values.spiideo_scene_uuid, 'spiideo_scene_uuid'));
    Object.assign(errors, validators.uuid(values.spiideo_scene_uuid, 'spiideo_scene_uuid'));
    Object.assign(errors, validators.maxLength({value: values.spiideo_scene_uuid, maxLength: 36}, 'spiideo_scene_uuid'));

    return errors;
};

export default validate;
